var OperationCheckTypes = /* @__PURE__ */ ((OperationCheckTypes2) => {
  OperationCheckTypes2[OperationCheckTypes2["Save"] = 1] = "Save";
  OperationCheckTypes2[OperationCheckTypes2["Update"] = 2] = "Update";
  OperationCheckTypes2[OperationCheckTypes2["Clone"] = 3] = "Clone";
  OperationCheckTypes2[OperationCheckTypes2["Start"] = 4] = "Start";
  OperationCheckTypes2[OperationCheckTypes2["Advance"] = 5] = "Advance";
  OperationCheckTypes2[OperationCheckTypes2["Stop"] = 6] = "Stop";
  OperationCheckTypes2[OperationCheckTypes2["EmergencyStop"] = 7] = "EmergencyStop";
  OperationCheckTypes2[OperationCheckTypes2["BatchStartOrAdvance"] = 8] = "BatchStartOrAdvance";
  OperationCheckTypes2[OperationCheckTypes2["Transfer"] = 9] = "Transfer";
  return OperationCheckTypes2;
})(OperationCheckTypes || {});
var TransitionGateStates = /* @__PURE__ */ ((TransitionGateStates2) => {
  TransitionGateStates2["Fail"] = "Fail";
  TransitionGateStates2["NotSet"] = "NotSet";
  TransitionGateStates2["Pass"] = "Pass";
  TransitionGateStates2["Override"] = "Override";
  TransitionGateStates2["Waiting"] = "Waiting";
  return TransitionGateStates2;
})(TransitionGateStates || {});
var DisabledInfoLevel = /* @__PURE__ */ ((DisabledInfoLevel2) => {
  DisabledInfoLevel2[DisabledInfoLevel2["InfoOnly"] = 3] = "InfoOnly";
  DisabledInfoLevel2[DisabledInfoLevel2["LowPriority"] = 0] = "LowPriority";
  DisabledInfoLevel2[DisabledInfoLevel2["HighPriority"] = 5] = "HighPriority";
  return DisabledInfoLevel2;
})(DisabledInfoLevel || {});
export {
  DisabledInfoLevel,
  OperationCheckTypes,
  TransitionGateStates
};
//# sourceMappingURL=OperationCheckModels.js.map
